import React, { useEffect } from 'react';
import ContactForm from './ContactForm';

const Contact = () => {
  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <ContactForm
      subjectPlaceholder="What's this about?"
      subjectDefault="General Inquiry"
      headingLevel="h2"
      showInfo={true}
      onSuccess={() => {
        setTimeout(() => {
          window.location.href = '/thanks';
        }, 800);
      }}
    />
  );
};

export default Contact;
